import { migrateAffineCssVar } from '@blocksuite/affine-model';
import type { StyleInfo } from 'lit/directives/style-map.js';

import type { AffineTextAttributes } from '../types';

/**
 * Migrate a CSS value that may contain `var(--affine-...)` to `var(--streamlain-...)`.
 * Handles both bare variable names (`--affine-x`) and wrapped references (`var(--affine-x)`).
 */
function migrateCssValue(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  if (value.startsWith('--affine-')) return migrateAffineCssVar(value);
  if (value.includes('--affine-')) {
    return value.replace(/--affine-/g, '--streamlain-');
  }
  return value;
}

export function affineTextStyles(
  props: AffineTextAttributes,
  override?: Readonly<StyleInfo>
): StyleInfo {
  let textDecorations = '';
  if (props.underline) {
    textDecorations += 'underline';
  }
  if (props.strike) {
    textDecorations += ' line-through';
  }

  let inlineCodeStyle = {};
  if (props.code) {
    inlineCodeStyle = {
      'font-family': 'var(--streamlain-font-code-family)',
      background: 'var(--streamlain-background-code-block)',
      border: '1px solid var(--streamlain-border-color)',
      'border-radius': '4px',
      color: 'var(--streamlain-text-primary-color)',
      'font-variant-ligatures': 'none',
      'vertical-align': 'bottom',
      'line-height': 'inherit',
    };
  }

  return {
    'font-weight': props.bold ? 'bolder' : 'inherit',
    'font-style': props.italic ? 'italic' : 'normal',
    'background-color': migrateCssValue(props.background),
    color: migrateCssValue(props.color),
    'text-decoration': textDecorations.length > 0 ? textDecorations : 'none',
    ...inlineCodeStyle,
    ...override,
  };
}
